import {EXPAND_CHAT, SEND_MESSAGE, TECHNICAL_ERROR, ADD_MESSAGE, CONNECTION_INFO_CHANGED} from '../actions';
import {ACTIVITY_DIRECTION} from '../constants/chat-message-type';
import globals from '../services/globals';
import {EDITOR_VIEW_MODE} from '../constants/editor-view-mode';
import wix from '../utils/wix';
import events from './events';

const nullify = val => val || 'null';

const log = (biLogger, params) => {
  if (wix.isInView(EDITOR_VIEW_MODE.SITE)) {
    biLogger.log({...params,
      bi_token: globals.biToken, visitor_id: nullify(globals.visitorId), app_instance_id: globals.instanceId}); // eslint-disable-line camelcase
  }
};

const technicalError = ({biLogger, action}) => {
  if (action.type === TECHNICAL_ERROR && action.isError) {
    log(biLogger, {...events.technicalError});
  }
};

const sendMessage = ({action, biLogger}) => {
  if (action.type === `${SEND_MESSAGE}_PENDING`) {
    log(biLogger, {...events.sendMessage});
  }
};

const expandChat = ({action, biLogger}) => {
  if (action.type === EXPAND_CHAT) {
    log(biLogger, {...events.expandChat, direction: action.initiator});
  }
};

const connectionInfo = ({action, biLogger}) => {
  if (action.type === CONNECTION_INFO_CHANGED) {
    const {connectionIsOn, lastDisconnectionTime, isInitial} = action.connectionInfo;
    connectionIsOn ?
      log(biLogger, {...events.firebaseConnectionOn, shard_id: nullify(globals.shardId), initial_connection: isInitial, idle_time: Date.now() - lastDisconnectionTime}) : // eslint-disable-line camelcase
      log(biLogger, {...events.firebaseConnectionOff, shard_id: nullify(globals.shardId), initial_connection: isInitial}); // eslint-disable-line camelcase
  }
};

const realtimeActivity = ({action, biLogger}) => {
  if (action.type === ADD_MESSAGE) {
    if (action.meta.activity.direction === ACTIVITY_DIRECTION.BUSINESS_TO_CUSTOMER) {
      log(biLogger, {...events.realtimeActivity, shard_id: nullify(globals.shardId)}); // eslint-disable-line camelcase
    }
  }
};

const biLoggerMiddleware = biLogger => ({getState}) => next => action => {
  try {
    const args = {biLogger, getState, next, action};
    technicalError(args);
    sendMessage(args);
    expandChat(args);
    realtimeActivity(args);
    connectionInfo(args);
  } catch (ex) {
    //swallow exceptions here because we need to continue the actions even if logging fails
    console.warn('BI Failure', ex);
  } finally {
    return next(action); // eslint-disable-line no-unsafe-finally
  }
};



export default biLoggerMiddleware;



// WEBPACK FOOTER //
// ./chat-app/biLogger/biLogger.middleware.js